import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Loader from '../../../components/Loader'

import { useTrainingCategoryContent } from '../../../hooks/Others/LearningAndDevelopment/useTrainingCategoryContent'
import AddTrainingCategoryContent from './AddTrainingCategoryContent'

export default function EditTrainingCategoryContent() {
  const { trainingCategoryContent, getTrainingCategoryContent } = useTrainingCategoryContent()
  const params = useParams()
  useEffect(() => {
    getTrainingCategoryContent({ _id: params.trainingCategoryContentId })
  }, [params.trainingCategoryContentId])

  return <> {trainingCategoryContent ? <AddTrainingCategoryContent trainingCategoryContent={trainingCategoryContent} /> : <Loader />} </>
}
